import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { GetSessionData } from "../services/AuthService";
import TripleDotLoadingProgress from "../components/tools/TripleDotLoadingProgress";

interface RegistrationAccessGuardProps {
  children: React.ReactNode;
}

const RegistrationAccessGuard: React.FC<RegistrationAccessGuardProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [redirectPath, setRedirectPath] = useState<string | null>(null);
  const referrer = document.referrer;
  const isScholarMaps = referrer && referrer.includes('scholar-maps.com');
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;

    GetSessionData()
      .then(res => {
        if (!isMounted) return;
        
        if (res && res.is_logged_in) {
          const onboardingStatus = res.onboarding_status;
          
          if (onboardingStatus && onboardingStatus !== 'finished') {
            const currentPath = location.pathname;
            const searchParams = new URLSearchParams(location.search);
            const currentStep = searchParams.get('_s');
            
            if (currentPath === '/onboarding/registration' && currentStep) {
              setRedirectPath(null);
              return;
            }
            
            let stepParam = '1';
            if (onboardingStatus === 'bootstrapped') stepParam = '2';
            else if (onboardingStatus === 'trained') stepParam = '3';
            
            setRedirectPath(`/onboarding/registration?_s=${stepParam}`);
            return;
          }
          
          setRedirectPath(isScholarMaps ? "/scholar-maps" : "/");
        } else {
          setRedirectPath(null);
        }
      })
      .catch(() => {
        if (isMounted) {
          setRedirectPath(null);
        }
      })
      .finally(() => {
        if (isMounted) setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [isScholarMaps, location]);

  if (isLoading) {
    return <TripleDotLoadingProgress sx={{ display: "block", margin: "auto", mt: 4 }} />;
  }

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};

export default RegistrationAccessGuard;